// service-worker.service.ts
import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { Observable, Subject, of } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ServiceWorkerService {
    private swUpdate = inject(SwUpdate);
    private initComplete$ = new Subject<boolean>();

    init(): Observable<boolean> {
        if (!this.swUpdate.isEnabled) {
            console.log('Service Worker désactivé');
            this.initComplete$.next(true);
            this.initComplete$.complete();
            return of(true);
        }

        // Vérifier les mises à jour
        this.swUpdate.versionUpdates
            .pipe(
                filter(
                    (evt): evt is VersionReadyEvent =>
                        evt.type === 'VERSION_READY'
                )
            )
            .subscribe((event) => {
                console.log('Version actuelle:', event.currentVersion);
                console.log('Nouvelle version:', event.latestVersion);
                this.promptUpdate();
            });

        // Gérer les erreurs critiques
        this.swUpdate.unrecoverable.subscribe((event) => {
            console.error('Erreur SW non récupérable:', event.reason);
            this.handleCriticalError();
        });

        // Vérification initiale
        this.swUpdate
            .checkForUpdate()
            .then(() => {
                console.log('Service Worker initialisé');
                this.initComplete$.next(true);
                this.initComplete$.complete();
            })
            .catch((err) => {
                console.error('Erreur init SW:', err);
                this.initComplete$.next(false);
                this.initComplete$.complete();
            });

        return this.initComplete$.asObservable();
    }

    private async promptUpdate() {
        const updateApp = confirm(
            'Nouvelle version disponible. Mettre à jour ?'
        );
        if (updateApp) {
            await this.swUpdate.activateUpdate();
            window.location.reload();
        }
    }

    private handleCriticalError() {
        if (confirm("Erreur critique. Recharger l'application ?")) {
            window.location.reload();
        }
    }
}
